import { useState } from "react";
import { useApi } from "./useAPI";
import { notify } from "../components/Toast/Toast";

export const useForm = (
	endpoint,
	method = "POST",
	isAlertMessage = false,
	isMultipart = false // New parameter to toggle form type
) => {
	const [formValues, setFormValues] = useState({});
	const [alertMessage, setAlertMessage] = useState();

	const { mutate, isLoading } = useApi(endpoint, method, isMultipart); // Pass isMultipart

	const handleChange = (e) => {
		const { name, type, files, value } = e.target;

		if (type === "file") {
			const fileArray = Array.from(files);

			setFormValues({ ...formValues, [name]: fileArray }); // Update state with file array
		} else {
			setFormValues({ ...formValues, [name]: value });
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		let dataToSend = formValues;
		console.log("dataToSend", dataToSend);

		if (isMultipart) {
			const formData = new FormData();

			Object.keys(formValues).forEach((key) => {
				if (key === "documents") {
					Array.from(formValues[key]).forEach((file) => {
						formData.append("documents", file);
					});
				} else if (key === "cv") {
					Array.from(formValues[key]).forEach((file) => {
						formData.append("cv", file);
					});
				} else if (key === "languages" && Array.isArray(dataToSend[key])) {
					dataToSend[key].forEach((lang) => {
						formData.append("languages[]", lang);
					});
				} else if (key === "qualifications" && Array.isArray(dataToSend[key])) {
					dataToSend[key].forEach((qual) => {
						formData.append("qualifications[]", qual);
					});
				} else {
					formData.append(key, formValues[key]);
				}
			});

			dataToSend = formData;

			console.log("FormData contents:");
			for (let [key, value] of formData.entries()) {
				console.log(key, value);
			}
		}

		mutate(dataToSend, {
			onSuccess: (response) => {
				const successMessage = response.message || "Form submitted successfully!";

				isAlertMessage ? setAlertMessage({ message: successMessage, type: "success" }) : notify(successMessage, "fas fa-check-circle");

				setFormValues({});
				setTimeout(() => {
					setAlertMessage();
				}, 5000);
			},
			onError: (error) => {
				const errorMessage =
					error.response?.data?.details?.map((detail) => detail).join(", ") ||
					error.response?.data?.errors?.[0] ||
					error.response?.data?.error ||
					error.response?.data?.message ||
					"Error submitting form.";

				isAlertMessage ? setAlertMessage({ message: errorMessage, type: "error" }) : notify(errorMessage, "fas fa-exclamation-circle");

				setTimeout(() => {
					setAlertMessage();
				}, 5000);
			},
		});
	};

	return { formValues, handleChange, handleSubmit, isLoading, alertMessage };
};
